import i from"styled-components";import{theme as o}from"../../../theme.js";const n=i.div`
  background-color: ${o.colors.secondary[900]};
  padding: ${o.spacing*12}px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${o.spacing*4}px;
  box-sizing: border-box;
  > h1, > p {
    color: ${o.colors.shades[0]};
    margin: 0;
    text-align: center;
  }
  > h1 {
    line-height: 42px;
  }
  > p {
    line-height: 32px;
  }
  @media screen and (max-width: ${o.breakpoints.md}) {
    padding: ${o.spacing*12}px ${o.spacing*4}px;
    width: 100%;
    > form {
      width: 100%;
    }
  }
`,r=i.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: ${o.spacing*4}px;
  padding: ${o.spacing}px;
  border-radius: ${o.radius}px;
  background-color: ${o.colors.shades[0]};
  width: 650px;
  box-sizing: border-box;
  > input {
    box-sizing: border-box;
    padding: 0 0 0 ${o.spacing*3}px;
    border: unset;
    outline: none;
    &::placeholder {
      font-size: 16px;
      color: ${o.colors.gray[400]};
    }
    color: ${o.colors.gray[900]};
  }
  @media screen and (max-width: ${o.breakpoints.md}) {
    width: 100%;
  }
`;export{n as Container,r as InputContainer};
